import {useState} from 'react';
import {Check, Lock, Star, Hourglass} from 'lucide-react';
import {theme} from "./RewardSystem";
import FileView from "../../../../core/components/file-view";
import RenderIf from "../../../../core/components/render-if";
import {CommonIcon} from "../../../../core/components/icon";

export default function RewardBubble({reward, status, onClick}) {
    const [isHovered, setIsHovered] = useState(false);
    const isEarned = reward?.beforeTakenStatus === "taken";
    const isAvailable = reward?.canGet === true;
    const isPending = reward?.beforeTakenStatus === 'pending_take';
    const isLocked = reward?.canGet === false && !isPending && !isEarned;



    const size = isEarned ? 110 : isAvailable ? 105 : isPending ? 100 : 90;

    const getBubbleStyle = () => {
        const base = {
            width: size,
            height: size,
            borderRadius: '50%',
            transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
            cursor: 'pointer',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            border: `3px solid`,
        };

        if (isEarned) {
            return {
                ...base,
                borderColor: theme.accent,
                background: `linear-gradient(135deg, ${theme.deep}cc, ${theme.primary}cc)`,
                boxShadow: `0 0 20px ${theme.light}44, 0 0 40px ${theme.primary}22`,
                transform: isHovered ? 'scale(1.12)' : 'scale(1)',
            };
        }
        if (isAvailable || isPending) {
            return {
                ...base,
                borderColor: theme.light,
                background: `linear-gradient(135deg, ${theme.primary}99, ${theme.deep}99)`,
                boxShadow: `0 0 25px ${theme.accent}55, 0 0 50px ${theme.light}33`,
                transform: isHovered ? 'scale(1.12)' : 'scale(1)',
                animation: 'pulse-glow 2s ease-in-out infinite',
            };
        }
        return {
            ...base,
            borderColor: '#555',
            background: 'linear-gradient(135deg, #2a2a3a, #1a1a2a)',
            opacity: 0.55,
            filter: 'grayscale(0.6)',
            transform: isHovered ? 'scale(1.05)' : 'scale(1)',
        };
    };

    return (
        <div
            dir={'rtl'}
            style={getBubbleStyle()}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => onClick?.(reward)}
            className="group select-none"
        >
            {isEarned && (
                <div
                    className="absolute -top-1 -right-1 z-10 rounded-full flex items-center justify-center"
                    style={{
                        width: 28,
                        height: 28,
                        background: `linear-gradient(135deg, #22c55e, #16a34a)`,
                        boxShadow: '0 2px 8px #22c55e66',
                        animation: 'check-pop 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                    }}
                >
                    <Check size={16} color="white" strokeWidth={3}/>
                </div>
            )}
            {isPending && (
                <div
                    className="absolute -top-1 -right-1 z-10 rounded-full flex items-center justify-center"
                    style={{
                        width: 28,
                        height: 28,
                        background: `linear-gradient(135deg, ${theme.yellow}, ${theme.primary})`,
                        boxShadow: `0 2px 10px ${theme.yellow}66`,
                        animation: 'sparkle 1.5s ease-in-out infinite',
                    }}
                >
                    <Hourglass size={16} color="white" strokeWidth={3}/>
                </div>
            )}
            {isLocked && !isEarned && !isPending && (
                <div
                    className="absolute -top-1 -right-1 z-10 rounded-full flex items-center justify-center"
                    style={{
                        width: 26,
                        height: 26,
                        background: 'linear-gradient(135deg, #555, #333)',
                        boxShadow: '0 2px 6px #00000044',
                    }}
                >
                    <Lock size={12} color="#999" strokeWidth={2.5}/>
                </div>
            )}

            {isAvailable && !isEarned && !isPending && (
                <div
                    className="absolute -top-1 -right-1 z-10 rounded-full flex items-center justify-center"
                    style={{
                        width: 28,
                        height: 28,
                        background: `linear-gradient(135deg, ${theme.accent}, ${theme.primary})`,
                        boxShadow: `0 2px 10px ${theme.accent}66`,
                        animation: 'sparkle 1.5s ease-in-out infinite',
                    }}
                >
                    <Star size={14} color="white" strokeWidth={2.5} fill="white"/>
                </div>
            )}

            <div
                className="rounded-full  overflow-hidden "
                style={{
                    width: isLocked ? 80 : 100,
                    height: isLocked ? 80 : 100,
                    // width: isEarned || isAvailable || isPending ? 48 : 38,
                    // height: isEarned || isAvailable || isPending ? 48 : 38,
                    // border: `2px solid ${isEarned ? theme.accent : isAvailable || isPending ? theme.light : '#444'}`,
                    // boxShadow: isEarned ? `0 0 10px ${theme.light}44` : 'none',
                }}
            >
                <RenderIf cond={!!reward?.fileDetail} falsyElement={
                    <div className="flex full items-center justify-center mt-2">
                        <CommonIcon icon={'award'}/>
                    </div>
                }>
                    <FileView {...reward?.fileDetail} imageClassName={'object-contain'}/>
                </RenderIf>
                {/*<img*/}
                {/*    src={reward.image}*/}
                {/*    alt={reward.title}*/}
                {/*    className="w-full h-full object-cover"*/}
                {/*    style={{*/}
                {/*        filter: isLocked ? 'grayscale(1) brightness(0.5)' : 'none',*/}
                {/*    }}*/}
                {/*/>*/}
            </div>

            {/*<span*/}
            {/*    className="text-center leading-tight font-bold px-1"*/}
            {/*    style={{*/}
            {/*        fontSize: isEarned || isAvailable || isPending ? 9 : 7,*/}
            {/*        color: isLocked ? '#666' : 'white',*/}
            {/*        textShadow: isAvailable || isPending ? `0 0 8px ${theme.accent}88` : 'none',*/}
            {/*        maxWidth: size - 16,*/}
            {/*        overflow: 'hidden',*/}
            {/*        textOverflow: 'ellipsis',*/}
            {/*        whiteSpace: 'nowrap',*/}
            {/*    }}*/}
            {/*>*/}
            {/*</span>   */}

            <RenderIf cond={reward?.score || reward?.experience}>
                            <span
                                className="absolute -top-2 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded-full text-white font-bold"
                                style={{
                                    fontSize: 8,
                                    background: `linear-gradient(90deg, ${theme.accent}, ${theme.primary})`,
                                    boxShadow: `0 2px 8px ${theme.accent}44`,
                                    whiteSpace: 'nowrap',
                                }}
                            >
                          {reward?.score} {reward?.experience}
                        </span>
            </RenderIf>
            <span
                className="absolute -bottom-2 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded-full items-center justify-center text-white font-bold"
                style={{
                    background: `linear-gradient(90deg, ${theme.accent}, ${theme.primary})`,
                    boxShadow: `0 2px 8px ${theme.accent}44`,
                    fontSize: 9,
                    color: isLocked ? '#d7d7d7' : 'white',
                    textShadow: isAvailable || isPending ? `0 0 8px ${theme.accent}88` : 'none',
                    // maxWidth: size - 16,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
              {reward?.title}
            </span>
        </div>
    );
}